import * as Sentry from "@sentry/react";

const DOMAIN = window.location.hostname;

type Environment = "production" | "staging" | "development";

/* Sentry docs say that it is safe to have these keys public */
const DEFAULT_KEYS: Record<Environment, string | null> = {
  production: "https://f1249ebfab9c44ac8b24c80b656b621f@o80571.ingest.sentry.io/4505001686794240",
  staging: null,
  development: null,
};

function getEnvironment(): Environment {
  if (DOMAIN.includes("localhost")) {
    return "development";
  } else if (DOMAIN.includes("staging") || DOMAIN.includes("test")) {
    return "staging";
  } else {
    return "production";
  }
}

interface InitSentryParams {
  keys?: Partial<Record<Environment, string | null>>;
}

export function initSentry(params: InitSentryParams = {}) {
  const keys = params.keys ?? {};
  const environment = getEnvironment();
  const key = keys[environment] ?? DEFAULT_KEYS[environment];

  if (!key) return; // Disable logging if no key is provided

  Sentry.init({
    dsn: key,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0, // capture 100% of transactions
    ignoreErrors: [
      "ResizeObserver loop limit exceeded", // Common harmless errors
      "Network Error",
    ],
    beforeSend(event) {
      // Prevent logging non critical errors
      if (
        event.exception &&
        event.exception.values?.some((ex) => ex.value?.includes("NonCriticalError"))
      ) {
        return null;
      }
      return event;
    },
  });
}
